import runtimeConfig from '@super-template/core/src/runtimeConfig/index.js';
import {
  KEIKKALAISTUNNUSTILAUS,
  LUOTTAMUSHENKILOLOMAKE,
  LUOTTAMUSHENKILOLOMAKE2,
} from './components/Form/FormTypes.js';
import { ResponseStatus } from './constants.js';
import CheckCircleIcon from '@material-ui/icons/CheckCircle.js';
import CancelIcon from '@material-ui/icons/Cancel.js';
import AddCircleIcon from '@material-ui/icons/AddCircle.js';
import EditIcon from '@material-ui/icons/Error.js';
import React from 'react';

// Determine if form needs PASSWORD (organization pin is different from this, so we cannot use isLocked())
export const isPasswordProtectedForm = (formId) => {
  if (
    formId.toString() === runtimeConfig.keikkalaistunnusForm.id.toString() ||
    formId.toString() === runtimeConfig.jasenenHenkilotietoForm.id.toString() ||
    formId.toString() === runtimeConfig.henkilotietoForm.id.toString() ||
    formId.toString() === runtimeConfig.sidonnaisuusForm.id.toString()
  ) {
    return true;
  } else {
    return false;
  }
};

export const determineFormName = (id) => {
  switch (id) {
    case runtimeConfig.keikkalaistunnusForm.id.toString():
      return KEIKKALAISTUNNUSTILAUS;

    case runtimeConfig.jasenenHenkilotietoForm.id.toString():
    case runtimeConfig.henkilotietoForm.id.toString():
      return LUOTTAMUSHENKILOLOMAKE;

    case runtimeConfig.sidonnaisuusForm.id.toString():
      return LUOTTAMUSHENKILOLOMAKE2;

    default:
      return false;
  }
};

export const getFormResponseStatusIcon = (responseStatus) => {
  switch (responseStatus) {
    case ResponseStatus.ACCEPTED:
      return <CheckCircleIcon style={{ color: 'green' }} />;

    case ResponseStatus.REJECTED:
      return <CancelIcon style={{ color: 'red' }} />;

    case ResponseStatus.VERIFIED:
      return <CheckCircleIcon color="primary" />;

    case ResponseStatus.ADMIN_EDITED:
      return <EditIcon style={{ color: 'orange' }} />;

    case ResponseStatus.PENDING:
    default:
      return <AddCircleIcon color="primary" />;
  }
};
